<template>
	<div>
		<v-data-table
			hide-default-footer
			:items="items"
			item-key="id"
			:headers="colunas"
			single-expand
			show-expand
			:expanded.sync="expandeds"
			:items-per-page="paginacaoInterna.rowsPerPage"
			:page="paginacaoInterna.page"
		>
			<template #item.descricao="{ item }">
				<texto-tooltip :texto="item.descricao" :tamanho-maximo="textoTamanhoMaximo"></texto-tooltip>
			</template>
			<template #item.saldoAta="{ item }">
				<span v-if="!(item.valorAcrescido || item.valorSuprimido)">{{ item.estoqueInicial | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
				<v-tooltip top color="black" v-if="item.valorAcrescido || item.valorSuprimido">
					<template #activator="{ on }">
						<div>
							<v-icon
								v-on="on"
								small
								color="orange"
							>mdi-alert</v-icon>
							<span>
								{{ (item.estoqueInicial + (item.valorAcrescido || 0) - (item.valorSuprimido || 0)) | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
							</span>
						</div>
					</template>
					<div>
						<span>{{ 'Saldo Inicial: '}}{{ item.estoqueInicial | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
						<br v-if="item.valorAcrescido"/>
						<span v-if="item.valorAcrescido">{{ 'Acréscimo: ' }}{{ item.valorAcrescido | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
						<br v-if="item.valorSuprimido"/>
						<span v-if="item.valorSuprimido">{{ 'Supressão: '}}{{ (item.valorSuprimido * -1) | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
					</div>
				</v-tooltip>
			</template>
			<template #item.saldoAtual="{ item }">
				<span>{{ item.estoqueAtual | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
			</template>
			<template #expanded-item="{ headers, item }">
				<td :colspan="headers.length" style="padding: 0 !important">
					<listagem-de-orgaos-por-item
						v-if="expandeds.length"
						:info-item-ata="expandeds[0]"
						@abrir-detalhes="abrirDetalhes"
					></listagem-de-orgaos-por-item>
				</td>
			</template>
		</v-data-table>
		<paginacao-tabela
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			@paginar="$emit('paginar')"
			:show-rows-per-page="false"
			@resetar-page="resetarPaginaListagem"
		></paginacao-tabela>
		<modal-listar-detalhes
			v-if="exibirModalDetalhes"
			v-model="exibirModalDetalhes"
			:titulo-modal="`Detalhes do saldo: ${itemAtaDetalhe.infoSaldo}`"
			:id-item="itemAtaDetalhe.idDetalhe"
			:pedido-detalhe="pedidoDetalhe"
			:total-paginas="listagemModalDetalhes.totalPaginas"
			:total-itens="listagemModalDetalhes.totalItens"
			:paginacao="listagemModalDetalhes.paginacao"
		></modal-listar-detalhes>
	</div>
</template>
<script>
import { TabelaColunaUtils } from '@/core/utils'
import tabela from '@/views/mixins/tabela'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import listagemDeOrgaosPorItem from './component/ListagemDeOrgaosPorItem.vue'
import modalListarDetalhes from '@/views/pages/ata/acessar/gestao-da-ata/acompanhamento/listagem/component/modal/ModalListarDetalhes.vue'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	name: 'ata-acompanhamento-listagem',
	components: { modalListarDetalhes, PaginacaoTabela, listagemDeOrgaosPorItem },
	mixins: [tabela],
	props: {
		items: {
			type: Array,
			required: true,
		},
	},
	emits: ['botao-evento', 'paginar'],
	data() {
		return {
			itemAtaDetalhe: {},
			pedidoDetalhe: {},
			exibirModalDetalhes: false,
			listagemModalDetalhes: {
				totalItens: 0,
				totalPaginas: 1,
				paginacao: PaginacaoListagem(['seq']),
				datasource: [],
			},
			expandeds: [],
			colunas: [
				new TabelaColunaUtils('Tipo', 'tipo', '8%'),
				new TabelaColunaUtils('Seq', 'item', '8%'),
				new TabelaColunaUtils('Descrição', 'descricao', '50%'),
				new TabelaColunaUtils('Saldo Ata', 'saldoAta', '14%'),
				new TabelaColunaUtils('Saldo Atual', 'saldoAtual', '14%'),
				new TabelaColunaUtils('', 'data-table-expand', '6%', 'end'),
			],
			paginacaoInterna: this.paginacao,
			textoTamanhoMaximo: 100,
		}
	},
	computed: {
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisQtde
			},
		},
	},
	methods: {
		abrirDetalhes({ itemAtaDetalhe, pedidoDetalhe }) {
			this.exibirModalDetalhes = true
			this.itemAtaDetalhe = {
				idDetalhe: itemAtaDetalhe.idOrgao,
				infoSaldo: itemAtaDetalhe.orgaoSigla,
			}
			this.pedidoDetalhe = {
				tipo: pedidoDetalhe.tipo,
				item: pedidoDetalhe.descricao,
				idItem: pedidoDetalhe.id,
			}
		},
		resetarPaginaListagem() {
			this.paginacaoInterna.page = 1
		},
	},
}
</script>
<style scoped lang="stylus">
>>> .v-data-table__wrapper {
	overflow-x: hidden
	overflow-y: hidden
}
.border-box {
	border: solid 1px !important;
	border-color: #80808054 !important;
	border-radius: 0px 0px 10px 10px !important;
	border-style: none solid solid solid !important;
	margin-bottom: 5px;
}

.description-limitation
	text-overflow: ellipsis;
	overflow: hidden;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	display: block;
	display: -webkit-box;
	max-height: 48px;

>>> .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
	box-shadow: none !important;
}
</style>
